/**
 * Combina y filtra nombres de clases CSS.
 * Acepta strings, arrays y objetos (clave → valor truthy incluye la clase).
 *
 * @example
 * classNames('foo', 'bar')                    // => 'foo bar'
 * classNames('foo', { bar: true, baz: false }) // => 'foo bar'
 * classNames(['foo', null, 'bar'])           // => 'foo bar'
 * classNames('foo', condition && 'bar')      // => 'foo bar' o 'foo'
 */
export const classNames = (...args) => {
  var classes = [];

  for (var i = 0; i < args.length; i++) {
    var arg = args[i];
    if (arg == null || typeof arg === 'boolean') continue;

    if (typeof arg === 'string') {
      var trimmed = arg.trim();
      if (trimmed) classes.push(trimmed);
      continue;
    }

    if (Array.isArray(arg)) {
      var result = classNames.apply(undefined, arg);
      if (result) classes.push(result);
      continue;
    }

    if (typeof arg === 'object') {
      for (var key in arg) {
        if (Object.prototype.hasOwnProperty.call(arg, key) && arg[key]) {
          classes.push(key);
        }
      }
    }
  }

  return classes.filter(Boolean).join(' ');
}
